itsoftApp.createModule("shareButtons", ["pageLoad"], function() {
    var initShare = function () {
        var btns, getButtonService, pageDescription, pageImage, pageTitle, pageUrl, services;
        btns = document.querySelectorAll(".js-share-btn");
        if (!btns.length) {
            return false;
        }

        // Share url templates
        // for different services
        services = {
            "vk": {
                "href": "https://vk.com/share.php?url={{url}}&title={{title}}&description={{description}}&image={{image}}"
            },
            "fb": {
                "href": "https://www.facebook.com/sharer.php?u={{url}}&description={{description}}&caption={{title}}&picture={{image}}"
            },
            "twi": {
                "href": "https://twitter.com/share?url={{url}}&text={{description}}"
            },
            "ok": {
                "href": "https://connect.ok.ru/offer?url={{url}}&title={{title}}&description={{description}}&imageUrl={{image}}"
            }
        };

        // Helper
        getButtonService = function(btn) {
            var res;
            if (!btn) {
                return;
            }
            res = undefined;

            // TODO: При желании - сделать по-нормальному
            if (btn.classList.contains("js-share--vk")) {
                res = "vk";
            } else if (btn.classList.contains("js-share--fb")) {
                res = "fb";
            } else if (btn.classList.contains("js-share--twi")) {
                res = "twi";
            } else if (btn.classList.contains("js-share--ok")) {
                res = "ok";
            }

            return res;
        };

        // Obtain main page variables
        pageUrl = window.location.protocol + "//" + window.location.hostname || "";

        if (window.location.href.indexOf("/en/") !== -1) {
            pageUrl += "/en/"
        }

        pageTitle = (function() {
            var res;
            if (document.querySelector("head meta[property='og:title']")) {
                res = document.querySelector("head meta[property='og:title']").getAttribute("content");
            } else if (document.querySelector("head title")) {
                res = document.querySelector("head title").textContent;
            } else {
                res = "";
            }
            return res;
        })();

        pageDescription = (function() {
            var res;
            if (document.querySelector("head meta[property='og:description']")) {
                res = document.querySelector("head meta[property='og:description']").getAttribute("content");
            } else if (document.querySelector("head meta[name='description']")) {
                res = document.querySelector("head meta[name='description']").getAttribute("content");
            } else {
                res = "";
            }
            return res;
        })();

        pageImage = (function() {
            var res;
            if (document.querySelector("head meta[property='og:image']")) {
                res = document.querySelector("head meta[property='og:image']").getAttribute("content");
            } else {
                res = "";
            }
            return res;
        })();

        DEBUG && console.log("[module shareButtons] pageUrl: " + pageUrl + ", pageTitle: " + pageTitle + ", pageDescription: " + pageDescription + ", pageImage: " + pageImage);


        // Methods

        Array.prototype.forEach.call(btns, function(btn) {
            var href, service;
            service = getButtonService(btn);
            if (!service) {
                return;
            }

            href = services[service].href;
            if (service === "twi" && !pageDescription) {
                pageDescription = pageTitle;
            }

            href = href.replace("{{url}}", encodeURIComponent(pageUrl));
            href = href.replace("{{title}}", encodeURIComponent(pageTitle));
            href = href.replace("{{description}}", encodeURIComponent(pageDescription));
            href = href.replace("{{image}}", encodeURIComponent(pageImage));

            btn.setAttribute("rel", "nofollow");
            btn.setAttribute("target", "_blank");
            btn.setAttribute("href", href);

            btn.onclick = function(e) {
                window.open(href, "", "toolbar=0,status=0,width=626,height=436");
                console.log(services)
                console.log(pageUrl);
                e.preventDefault();
            };
        });
    }

    itsoftApp.modules.pageLoad.addEvent(initShare);
});
